// extracted by mini-css-extract-plugin
export default {"Menu":"PopupMenu_Menu__64MBP"};